export default __webpack_public_path__ + "static/media/Queso viejo.92eb52ce.jpeg";